export class ValidateUtil {
    //Not in use?
    static isEqualString(a: string, b: string, caseSensitive: boolean = false) {
        if (caseSensitive) {
            if (a === b) {
                return true;
            }
        } else {
            if (a.toLowerCase() === b.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isValidEmail(emailAddress: string, useRfc2822Format: boolean = false): boolean {
        if (useRfc2822Format) {
            //TODO include to level domain checks...
            return /[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(emailAddress);
        } else {
            const reg = new RegExp('\\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}\\b', 'i');
            return reg.test(emailAddress.trim().toUpperCase());
        }

    }
}